import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; // Import HelmetProvider

// All pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Career from "./pages/Career";
import BlogList from "./pages/BlogList";
import BlogDetail from "./pages/BlogDetails";
import PortfolioPage from "./pages/PortfolioPage";

import { useDocTitle } from "./components/CustomHook";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic"
      });
    };

    window.addEventListener("load", () => {
      aos_init();
    });
  }, []);

  useDocTitle("TeqnoDux");

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/career" element={<Career />} />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blogs/:id" element={<BlogDetail />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </HelmetProvider>
  );
}

export default App;
